import * as R from "ramda";
import { call, reducer } from "../../helpers/api/meta";
import {
  deleteClass,
  getEvents,
  getEventsPost,
  getEventToken,
  getMeetingCreateClassroom,
  getEventTypes,
  getUsers,
  patchEvent,
  postEvents,
  postEventsClassroom,
  postEventToken,
  deleteAssign,
} from "../../helpers/api/api";
import { errorToBeAdded } from "../error";
import { started, response, failure } from "../../helpers/api/meta";

// Action types
export const GET_EVENTS_DATA = "GET_EVENTS_DATA";
export const GET_EVENT_TYPES_DATA = "GET_EVENT_TYPES_DATA";
export const GET_EVENT_TOKEN_DATA = "GET_EVENT_TOKEN_DATA";
export const GET_MEETING_CREATE_CLASSROOM = "GET_MEETING_CREATE_CLASSROOM";
export const GET_USERS = "GET_USERS";
export const GET_EVENT_POST_DATA = "GET_EVENT_POST_DATA";
export const POST_EVENT_TOKEN = "POST_EVENT_TOKEN";
export const POST_EVENTS_DATA = "POST_USERS_DATA";

// API calls

export const callGetEvents = (inputs) => {
	const meta = {
		endpoint: (params) => getEvents(params),
		inputs,
		action: GET_EVENTS_DATA,
		messages: {
			id: "getEvents",
			failure: "Could not get event detail",
		},
	};
	return call(meta);
};



export const callGetEventsPost = (inputs) => {
	const meta = {
		endpoint: (inputs) => getEventsPost(inputs),
		inputs,
		action: GET_EVENT_POST_DATA,
		messages: {
			id: "postEvents",
			failure: "Could not post data",
		},
	};
	return call(meta);
};

export const callPostEventData = (inputs) => {
	const meta = {
		endpoint: (inputs) => postEvents(inputs),
		inputs,
		action: POST_EVENTS_DATA,
		messages: {
			id: "postEvents",
			failure: "Could not post data",
		},
	};
	return call(meta);
};
export const callPostEventDataClassroom = (inputs) => {
 const meta = {
   endpoint: (inputs) => postEventsClassroom(inputs),
   inputs,
   action: POST_EVENTS_DATA,
   messages: {
     id: "postEvents",
     failure: "Could not post data",
   },
 };
 return call(meta);
};

export const callPatchEventData = (inputs) => {
	const meta = {
		endpoint: (inputs) => patchEvent(inputs),
		inputs,
		action: POST_EVENTS_DATA,
		messages: {
			id: "postEvents",
			failure: "Could not update data",
		},
	};
	return call(meta);
};

export const callDeleteClassData = (inputs) => {
  const meta = {
    endpoint: (id) => deleteClass(inputs),
    inputs,
    action: POST_EVENTS_DATA,
    messages: {
      id: "postEvents",
      failure: "Could not delete data",
    },
  };
  return call(meta);
};

export const callGetEventTypes = (inputs) => {
	const meta = {
		endpoint: (params) => getEventTypes(params),
		inputs,
		action: GET_EVENT_TYPES_DATA,
		messages: {
			id: "getEventTypes",
			failure: "Could not get event types",
		},
	};
	return call(meta);
};

export const callGetEventToken = (inputs) => {
	const meta = {
		endpoint: (params) => getEventToken(params),
		inputs,
		action: GET_EVENT_TOKEN_DATA,
		messages: {
			id: "getEventToken",
			failure: "Could not get event token",
		},
	};
	return call(meta);
};

export const callGetMeetingCreateClassroom = (inputs) => {
	const meta = {
		endpoint: (params) => getMeetingCreateClassroom(params),
		inputs,
		action: GET_MEETING_CREATE_CLASSROOM,
		messages: {
			id: "getMeetingCreateClassroom",
			failure: "Could not get event token",
		},
	};
	return call(meta);
};

export const callPostEventToken = (inputs) => {
	const meta = {
		endpoint: (inputs) => postEventToken(inputs),
		inputs,
		action: POST_EVENT_TOKEN,
		messages: {
			id: "postEventToken",
			failure: "Could not post data",
		},
	};
	return call(meta);
};

export const callGetUsers = (inputs) => {
	const meta = {
		endpoint: (params) => getUsers(params),
		inputs,
		action: GET_USERS,
		messages: {
			id: "getEventToken",
			failure: "Could not get event token",
		},
	};
	return call(meta);
};
  

// Reducer
const initialState = {
	loading: false,
	evnetDetail: {},
};
const saveEvents = (state, action) => {
	const newUsers = R.assoc("evnetDetail", action);
	return newUsers;
};
const messages = {
	loadFailed: "Could not load events.",
};
export default reducer(
	initialState,
	GET_EVENTS_DATA,
	saveEvents,
	messages.loadFailed
);


export const DELETE_ATTENDEES_DATA = "DELETE_ATTENDEES_DATA";
const errorMsg = "Unable to delete Assessment page Details";

export const callDeleteClassAssignData = (id) => (dispatch) => {
  dispatch(started(DELETE_ATTENDEES_DATA));
  return deleteAssign(id)
    .then((success) => {
      dispatch(response(DELETE_ATTENDEES_DATA));
      return success;
    })
    .catch((error) => {
      dispatch(failure(DELETE_ATTENDEES_DATA, error));
      dispatch(errorToBeAdded(error, "DeleteFailError", errorMsg));
    });
};
